module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web28.ce0242b5.jpg";